import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,LoadingController} from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import {CapconsegnaPage} from '../../pages/capconsegna/capconsegna';
/**
 * Generated class for the AddcapconsegnaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-addcapconsegna',
  templateUrl: 'addcapconsegna.html',
})
export class AddcapconsegnaPage {

  constructor(public navCtrl: NavController, public navParams: NavParams
    ,private readonly loadingCtrl: LoadingController, public rest: RestApiProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddcapconsegnaPage');
  }

  nuovoCapConsegna(values: any) {

    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',

      content: 'Aggiungi info ristorante ...'

    });

    loading.present();

     console.log('nuovoCapConsegna :'+JSON.stringify(values));
   
    this.rest.addCapConsegna(values);
    let hideFooterTimeout1 = setTimeout(() => {
      loading.dismiss();
      this.navCtrl.push(CapconsegnaPage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 1, 2); });

    }, 2000);

   


  }
}



// WEBPACK FOOTER //
// ./src/pages/addcapconsegna/addcapconsegna.ts